export default [
    {
        "id": "contact",
        "html": require('./contact/html').default,
        "css": require('./contact/css').default,
        "cssTablet": require('./contact/cssTablet').default,
        "cssMobile": require('./contact/cssMobile').default,
        "scss": require('./contact/scss').default,
        "scssTablet": require('./contact/scssTablet').default,
        "scssMobile": require('./contact/scssMobile').default,
        "js": require('./contact/js').default,
        "minJs": require('./contact/minJs').default,
        "pages": 'Contact'
    }
]